var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site, validatePhone } from '@debbie/common/dist';
import { BlameLogType } from '@debbie/common/dist/blamelog';
import { c } from '@debbie/cortex/dist';
import * as customersAPI from '@debbie/cortex/dist/api/customers';
import Button from '../../Button';
import Checkbox from '../../Checkbox';
import { PhoneOutgoing, PlusCircle } from '../../Icons';
import Input from '../../Input';
import Modal from '../../Modal';
import PhoneInput from '../../PhoneInput';
import Well from '../../Well';
import SecondaryEntity from './SecondaryEntity';
import UserInfoEntity from './UserInfoEntity';
const UserPhone = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [loading, setLoading] = useState(false);
    const [addSecondaryPhone, setAddSecondaryPhone] = useState(false);
    const [secondaryPhone, setSecondaryPhone] = useState(null);
    const [secondaryPhoneNote, setSecondaryPhoneNote] = useState('');
    const phoneValidation = details &&
        details.phoneValidations &&
        details.phoneValidations.find((pV) => (pV.phone && pV.phone.number) ==
            (details.phone && details.phone.number) &&
            (pV.phone && pV.phone.locale) ==
                (details.phone && details.phone.locale));
    const tags = []
        .concat(phoneValidation &&
        phoneValidation.originalCarrier &&
        phoneValidation.originalCarrier.name
        ? {
            content: phoneValidation.originalCarrier.name,
        }
        : [])
        .concat(phoneValidation &&
        phoneValidation.originalCarrier &&
        phoneValidation.originalCarrier.networkType
        ? {
            content: lang.phoneValidation[phoneValidation.originalCarrier.networkType] || phoneValidation.originalCarrier.networkType,
        }
        : [])
        .concat(phoneValidation &&
        phoneValidation.roaming &&
        phoneValidation.roaming.status &&
        phoneValidation.roaming.status != 'not_roaming'
        ? {
            content: lang.phoneValidation[phoneValidation.roaming.status] || phoneValidation.roaming.status,
        }
        : [])
        .concat(phoneValidation &&
        phoneValidation.reachable &&
        !['reachable', 'unknown'].includes(phoneValidation.reachable)
        ? {
            content: phoneValidation.reachable,
        }
        : []);
    return (React.createElement(React.Fragment, null,
        React.createElement(UserInfoEntity, { tags: tags, title: lang.debtorInfo.phone, value: details.phone, nextToInfo: props.user.subscribedToCosmo && site === Site.Caseworker ? (React.createElement("div", { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.customers.addSecondaryPhones, onClick: () => setAddSecondaryPhone(!addSecondaryPhone), style: { display: 'inline-block', marginRight: '5px' } },
                React.createElement(PlusCircle, { style: { cursor: 'pointer' } }))) : undefined, renderEditor: (selectedValue) => (React.createElement(PhoneInput, { phone: details.phone, onChange: (phone) => __awaiter(void 0, void 0, void 0, function* () {
                    phone = phone && phone.number && phone.locale ? phone : null;
                    selectedValue(phone);
                    yield props.patchUser({
                        phone,
                    }, {
                        details: phone,
                        type: BlameLogType.DebtorUpdatePhone,
                    });
                }), autofocus: true })), renderValue: (value) => {
                return ((value && value.locale && value.number && (React.createElement(React.Fragment, null,
                    React.createElement("a", { href: `tel:${value && value.number
                            ? `${value && value.locale ? `${value.locale}` : ''}
            ${value && value.number}`
                            : null}`, style: { color: 'inherit' } },
                        React.createElement(PhoneOutgoing, { style: { margin: '.2em .3em -.2em  0px' } }),
                        ' ',
                        value && value.number
                            ? `${value && value.locale ? `+${value.locale} ` : ''}
            ${value && value.number}`
                            : null)))) || React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.phone));
            }, hist: details.phoneHist && !!details.phoneHist.length
                ? details.phoneHist
                : undefined, onChange: (val) => __awaiter(void 0, void 0, void 0, function* () { }), removable: true }),
        props.user.details.secondaryPhones && (React.createElement("div", null,
            props.user.details.secondaryPhones.map((secondaryPhone) => (React.createElement(SecondaryPhone, { key: secondaryPhone.id, secondaryPhone: secondaryPhone, user: props.user }))),
            React.createElement("br", null))),
        addSecondaryPhone && (React.createElement(React.Fragment, null,
            React.createElement(Well, null,
                React.createElement(Input, { placeholder: lang.customers.note, value: secondaryPhoneNote, onChange: (e) => setSecondaryPhoneNote(e.target.value) }),
                React.createElement(PhoneInput, { placeholder: lang.debtorInfo.phone, phone: secondaryPhone, onChange: (p) => setSecondaryPhone(p), noSaveOnValid: true }),
                React.createElement(Button, { size: "small", loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        setLoading(true);
                        yield customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
                            type: 'addSecondaryPhone',
                            details: {
                                id: crypto.randomUUID(),
                                phone: secondaryPhone,
                                note: secondaryPhoneNote,
                                enabled: true,
                            },
                        });
                        yield c.customers.getById(props.user.customerId);
                        setSecondaryPhone(null);
                        setSecondaryPhoneNote('');
                        setAddSecondaryPhone(false);
                        setLoading(false);
                    }), block: true, disabled: !validatePhone(secondaryPhone) }, lang.customers.addSecondaryPhone)),
            React.createElement("br", null)))));
};
export default UserPhone;
const SecondaryPhone = (props) => {
    const { phone, enabled, id, note } = props.secondaryPhone;
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [_note, setNote] = useState(note);
    const [_phone, setPhone] = useState(phone);
    const [_enabled, setEnabled] = useState(enabled);
    return (React.createElement(SecondaryEmailStyled, null,
        React.createElement(SecondaryEntity, { toggleEditModal: () => setEditModalOpen(!editModalOpen), deleteEventType: "deleteSecondaryPhone", id: id, note: note || null, user: props.user, enabled: enabled, render: React.createElement(React.Fragment, null,
                "+",
                phone.locale,
                " ",
                phone.number) }),
        editModalOpen && (React.createElement(Modal, { maxWidth: "500px", onToggle: () => setEditModalOpen(!editModalOpen) },
            React.createElement(Checkbox, { placeholder: lang.customers.enabled, checked: _enabled, onChange: (e) => setEnabled(e.target.checked) }),
            React.createElement(Input, { placeholder: lang.customers.note, value: _note || '', onChange: (e) => setNote(e.target.value) }),
            React.createElement(PhoneInput, { placeholder: lang.debtorInfo.email, phone: _phone, onChange: (p) => p && setPhone(p), noSaveOnValid: true }),
            React.createElement(Button, { disabled: !((phone.number !== _phone.number ||
                    phone.locale !== _phone.locale ||
                    note !== _note ||
                    enabled !== _enabled) &&
                    validatePhone(_phone)), block: true, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    setLoading(true);
                    yield customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
                        type: 'patchSecondaryPhone',
                        details: Object.assign(Object.assign(Object.assign({ id }, (phone !== _phone ? { phone: _phone } : {})), (note !== _note ? { note: _note } : {})), (enabled !== _enabled ? { enabled: _enabled } : {})),
                    });
                    yield c.customers.getById(props.user.customerId);
                    setLoading(false);
                    setEditModalOpen(false);
                }), loading: loading }, lang.customers.save)))));
};
const SecondaryEmailStyled = styled.div `
  margin-bottom: 8px;
`;
//# sourceMappingURL=UserPhone.js.map